import { BTN_LIST_OPTION } from '../../renderOption';
import { BTN_MAP_KEY } from '../../enums/index';

/**
 * 初始化data数据
 * @returns 
 */
function getDefaultData () {
  return {
    content: null,
    isCanDraw: false, // 是否可绘制
    isCanEdit: false, // 是否可编辑
    handlerBack: null,
    addLamp: null,
    btnMap: new Map(),
    btnListNode: null,
    btnStyleNode: null,
    eventListeners: []
  }
}

const BTN_CLASSNAME = 'draw-canvas_btn';

/**
 * 按钮组件
 */
class BtnList {
  constructor(props) {
    const data = props || {};

    this.init(data);
  }

  data = getDefaultData();

  async init(props) {
    this.data = {
      ...this.data,
      ...props
    }
    this.createBtnList();
  }

  getData() {
    return this.data;
  }

  // 创建按钮列表
  createBtnList() {
    const { draw, edit, delete: delConfig, deleteLast, isSlash } = this.data.btnConfig || {};
    const btnList = document.createElement('div');
    const btnContainer = document.createElement('div');
    const btnStyle = document.createElement('style');

    btnList.className = 'draw-canvas_btn-list';
    btnContainer.className = 'draw-canvas_btn-list_container'
    btnStyle.innerHTML = BTN_LIST_OPTION.css;

    // 按钮配置
    const drawConfig = this.mergeBtnConfig(
      draw, BTN_LIST_OPTION.draw, BTN_MAP_KEY.DRAW, () => this.setIsCanDraw()
    );
    const editConfig = this.mergeBtnConfig(
      edit, BTN_LIST_OPTION.edit, BTN_MAP_KEY.EDIT, () => this.setIsCanEdit()
    );
    const deleteConfig = this.mergeBtnConfig(
      delConfig, BTN_LIST_OPTION.delete, BTN_MAP_KEY.DELETE, () => this.handlerDelete()
    );
    const deleteLastConfig = this.mergeBtnConfig(
      deleteLast, BTN_LIST_OPTION.deleteLast, BTN_MAP_KEY.DELETE_LAST, () => this.handlerDeleteLast()
    );
    const deleteAllConfig = this.mergeBtnConfig(
      {
        icon: 'scene-canvas_tool-icon scene-canvas_back',
        text: '清空画布',
        onclick: () => {},
        callBack: () => {}
      }, {
        isShow: true,
        key: 'deleteAll',
        text: '清空画布',
      }, 
      BTN_MAP_KEY.DELETE_ALL, 
      () => this.deleteAllDrawLayerLine()
    );

    // const isSlashConfig = this.mergeBtnConfig(
    //   isSlash, BTN_LIST_OPTION.isSlash, BTN_MAP_KEY.IS_SLASH, () => this.triggerAutoSlash()
    // );

    // 创建按钮
    [drawConfig, editConfig, deleteConfig, deleteLastConfig, deleteAllConfig].forEach(config => {
      config.isShow && this.createBtn(config, btnContainer);
    });
    
    btnList.appendChild(btnContainer);
    document.head.appendChild(btnStyle);
    this.data.content.appendChild(btnList);
    this.data.btnListNode = btnList;
    this.data.btnStyleNode = btnStyle;
  }

  // 混合按钮配置
  mergeBtnConfig(config = {}, defaultConfig, btnKey, fn) {
    return {
      ...defaultConfig,
      ...config,
      fn,
      btnKey
    }
  }

  // 创建按钮
  createBtn(config, btnContainer) {
    const btn = document.createElement('div');
    const clickHandler = () => {
      if (config.onclick instanceof Function)  config.onclick();

      config.fn();

      if (config.callBack instanceof Function)  config.callBack();
    };

    btn.className = BTN_CLASSNAME;
    btn.innerHTML = `<p>${config.text}</p>`;
  
    this.data.btnMap.set(config.btnKey, btn);

    if (config.icon) {
      btn.innerHTML = `<i class="${config.icon}"></i>` + btn.innerHTML
    }

    btn.addEventListener('click', clickHandler);
    this.data.eventListeners.push({
      target: btn,
      event: 'click',
      handler: clickHandler
    });

    btnContainer.appendChild(btn);
  }

  // 设置是否可以绘制
  setIsCanDraw = (boolean) => {
    const btnMap = this.data.btnMap;
    const isActive = boolean === void 0 ? !this.data.isCanDraw : boolean;

    btnMap.get(BTN_MAP_KEY.DRAW).className = isActive ? `${BTN_CLASSNAME} active` : BTN_CLASSNAME;
  
    this.data.isCanDraw = isActive;

    if (isActive) { 
      btnMap.get(BTN_MAP_KEY.EDIT).className = BTN_CLASSNAME;
      
      this.data.isCanEdit = false;
    }
  }

  // 设置是否可以编辑
  setIsCanEdit  = (boolean) => {
    const btnMap = this.data.btnMap;
    const isActive = boolean === void 0 ? !this.data.isCanEdit : boolean;
    
    btnMap.get(BTN_MAP_KEY.EDIT).className =  isActive ? `${BTN_CLASSNAME} active` : BTN_CLASSNAME;

    this.data.isCanEdit = isActive;

    if (isActive) {
      btnMap.get(BTN_MAP_KEY.DRAW).className = BTN_CLASSNAME;
      this.data.isCanDraw = false;
    }
  }

  // 删除
  handlerDelete = () => {
    this.data.handlerDelete && this.data.handlerDelete();
  }

  // 删除最后一根
  handlerDeleteLast = () => {
    this.data.handlerDeleteLast && this.data.handlerDeleteLast();
  }

  // 删除所有画布的线
  deleteAllDrawLayerLine() {
    this.data.deleteAllDrawLayerLine && this.data.deleteAllDrawLayerLine();
  }

  // 增加灯
  addLamp = () => {
    this.data.addLamp && this.data.addLamp()
  }

  $emit = () => {

  }

  triggerAutoSlash = () => {
    this.data.triggerAutoSlash();
    // this.data.triggerAutoSlash && this.data.triggerAutoSlash();
  }

  destroy() {
    if (!this.data) return;

    this.data.eventListeners.forEach(({ target, event, handler }) => {
      target.removeEventListener(event, handler);
    });
    this.data.eventListeners = [];

    if (this.data.btnMap) {
      this.data.btnMap.clear();
      this.data.btnMap = null;
    }

    if (this.data.btnListNode && this.data.btnListNode.parentNode) {
      this.data.btnListNode.parentNode.removeChild(this.data.btnListNode);
    }
    this.data.btnListNode = null;

    if (this.data.btnStyleNode && this.data.btnStyleNode.parentNode) {
      this.data.btnStyleNode.parentNode.removeChild(this.data.btnStyleNode);
    }
    this.data.btnStyleNode = null;

    this.data.content = null;
    this.data.handlerDelete = null;
    this.data.handlerDeleteLast = null;
    this.data.btnConfig = null;
    this.data = null;
  }
}

export default BtnList;